import { render, staticRenderFns } from "./DSRadioButton.vue?vue&type=template&id=41c444d3&scoped=true&"
import script from "./DSRadioButton.vue?vue&type=script&lang=js&"
export * from "./DSRadioButton.vue?vue&type=script&lang=js&"
import style0 from "./DSRadioButton.vue?vue&type=style&index=0&id=41c444d3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c444d3",
  null
  
)

export default component.exports